var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModul = function SvgModul(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A5A6FE",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.25 2.2a.45.45 0 0 1 .45-.45h5.665a.45.45 0 0 1 .45.45v5.665a.45.45 0 0 1-.45.45H2.7a.45.45 0 0 1-.45-.45zm0 9.935a.45.45 0 0 1 .45-.45h5.665a.45.45 0 0 1 .45.45V17.8a.45.45 0 0 1-.45.45H2.7a.45.45 0 0 1-.45-.45zm9.936 0a.45.45 0 0 1 .45-.45H18.3a.45.45 0 0 1 .45.45V17.8a.45.45 0 0 1-.45.45h-5.664a.45.45 0 0 1-.45-.45zm0-9.935a.45.45 0 0 1 .45-.45H18.3a.45.45 0 0 1 .45.45v5.665a.45.45 0 0 1-.45.45h-5.664a.45.45 0 0 1-.45-.45z"
  })));
};
export default SvgModul;